import type { LocationQuery } from 'vue-router'
import { getRedirectDestination } from '@/utils/redirect-destination'

export function getRootRedirect(query: LocationQuery): string {
  return getRedirectDestination(query.redirect)
}
